var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssesment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 2.66602H12.0003C12.3539 2.66602 12.6931 2.80649 12.9431 3.05654C13.1932 3.30659 13.3337 3.64573 13.3337 3.99935V13.3327C13.3337 13.6863 13.1932 14.0254 12.9431 14.2755C12.6931 14.5255 12.3539 14.666 12.0003 14.666H4.00033C3.6467 14.666 3.30756 14.5255 3.05752 14.2755C2.80747 14.0254 2.66699 13.6863 2.66699 13.3327V3.99935C2.66699 3.64573 2.80747 3.30659 3.05752 3.05654C3.30756 2.80649 3.6467 2.66602 4.00033 2.66602H5.33366",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 1.33398H5.99967C5.63148 1.33398 5.33301 1.63246 5.33301 2.00065V3.33398C5.33301 3.70217 5.63148 4.00065 5.99967 4.00065H9.99967C10.3679 4.00065 10.6663 3.70217 10.6663 3.33398V2.00065C10.6663 1.63246 10.3679 1.33398 9.99967 1.33398Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22266 7.40961C6.36187 7.01385 6.63666 6.68014 6.99835 6.46758C7.36003 6.25501 7.78528 6.17731 8.19877 6.24823C8.61226 6.31915 8.9873 6.53413 9.25748 6.85508C9.52765 7.17602 9.67552 7.58223 9.6749 8.00176C9.6749 9.18606 7.89844 9.77821 7.89844 9.77821",
    stroke: "#2A2A2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91992 11.5605H7.92881",
    stroke: "#2A2A2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssesment);
export default __webpack_public_path__ + "static/media/assesment.d9b69d3e5d9c712c494608fb747f8216.svg";
export { ForwardRef as ReactComponent };